import { axiosInstance } from './instance';

const getNotificationsStatic = (storeId) => {
    return axiosInstance.get(`/stores/${storeId}/notifications`);
};

export {
    getNotificationsStatic,
}